import React, { useEffect } from "react";

// react-router components
import { Route, Routes, useLocation, Navigate } from "react-router-dom";

import { createBrowserHistory } from "history";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Dashboard 2 PRO React themes
import theme from "./assets/theme";

import LayoutAdmin from './layouts/LayoutAdmin';
import LayoutAuth from './layouts/LayoutAuth';
import LayoutAuthApps from './layouts/LayoutAuthApps';
import LayoutFormularios from './layouts/LayoutFormularios';
import LayoutJuego from './layouts/LayoutJuego';
import OthelloClearCache from "./componentsothello/OthelloClearCache.jsx";
import LayoutCondicionesReservar from './layouts/LayoutCondicionesReservar';
import LayoutTicketReserva from './layouts/LayoutTicketReserva';
import LayoutPrivacidad from './layouts/LayoutPrivacidad';
import LayoutBajas from './layouts/LayoutBajas';

import CPageReportViewer from './componentsothello/CPageReportViewer';

import './report.css'

export default function App() {

    const { pathname } = useLocation();

    const hist = createBrowserHistory();

    // Setting page scroll to 0 when changing the route
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
    }, [pathname]);


    let direccion = "/auth/login";

    if (window.location.href.includes("gestor.ovtspain.es"))
        direccion = "/auth/login";
    else if (window.location.href.includes("reservas.ovtspain.es"))
        direccion = "/authapps/loginreservas";
    else if (window.location.href.includes("account.ovtspain.es"))
        direccion = "/authapps/loginapp";

    return (<ThemeProvider theme={/*darkMode ? themeDark :*/ theme}>
        <CssBaseline />
        <Routes navigation={hist}>
            <Route path="/auth/*" element={<LayoutAuth />} key="authentication" />
            <Route path="/admin/*" element={<LayoutAdmin />} key="dashmain" />
            <Route path='/authapps/*' element={<LayoutAuthApps />} key="authenticationapps" />
            <Route path='/formulario/*' element={<LayoutFormularios />} key="formulario" />
            <Route path='/game/*' element={<LayoutJuego />} key="game" />
            <Route path='/condiciones/*' element={<LayoutCondicionesReservar />} key="condiciones" />
            <Route path='/ticket/*' element={<LayoutTicketReserva />} key="ticket" />
            <Route path='/privacidad/*' element={<LayoutPrivacidad />} key="privacidad" />
            <Route path='/bajas/*' element={<LayoutBajas />} key="bajas" />
            <Route path='/report/*' element={<CPageReportViewer />} key="report" />
            <Route path="*" element={<Navigate to={direccion} />} />            
        </Routes>
    </ThemeProvider>
    );
}

